/** Scheduling-engine schedule entries use deploy.anchors[] (V3 contract). */
export const hasEngineScheduleDeploy = schedule => Array.isArray(schedule?.deploy?.anchors)

export {
  getVisitStudyDayNumber,
  resolveVisitAnchorStudyDay,
} from '../projection/engine/visitAnchorStudyDay'

export {
  resolveEngineAnchorStudyDay,
  resolveEngineScheduleStudyDay,
} from '../projection/engine/anchorStudyDay'
